// extracted by mini-css-extract-plugin
module.exports = {"root":"x_M","blurBackground":"x_bF","wrapper":"x_bG","branding":"x_bH","toggleNavButton":"x_bJ"};